// Feature switches read at build time. Public account registration was temporarily disabled
// (URS 4 Sep 2026, item 14) and reopened on 12 Oct 2026 per "JAIS - Changes Dashboard Sistem"
// (add "Daftar Pengguna"). It stays enabled unless explicitly turned off with
// REACT_APP_PUBLIC_REGISTRATION_ENABLED=false in the frontend .env.
export const PUBLIC_REGISTRATION_ENABLED = process.env.REACT_APP_PUBLIC_REGISTRATION_ENABLED !== 'false';
